import CryptoJS from "crypto-js";
import { ENCRYPT_KEY } from "lib/apiSecret";
import { FRONT_URL } from "lib/global";
import { serverPost } from "lib/serverRequest";
import { passwordResetTemplate } from "template/passwordResetEmail";

// export const deleteBoxMail = ({ data = {}, onFinish = () => {} }) => {
//   const emailTemplate = subscriptionCancelTemplate({
//     username: data?.name ?? "",
//     boxname: data?.other?.box_name ?? "",
//     linkUrl: `${window.location.origin}`,
//   });
//   serverPost({
//     url: "user/postmarkEmailSent",
//     data: {
//       // to: "rowellcamero08@gmail.com",
//       to: data?.email ?? "matpfaster26@gmail.com",
//       template: emailTemplate,
//       subject: "Box Subscription Cancelled",
//     },
//     onFinish: onFinish,
//   });
// };

// export const skipBoxMail = ({ data = {}, onFinish = () => {} }) => {
//   const emailTemplate = nextOrderSkipTemplate({
//     username: data?.name ?? "",
//     deliveryDate: getWeekDaysByWeekNumber(
//       Boolean(data?.week_next_num) ? data?.week_next_num : data?.week_num ?? 1,
//       data?.week_day ?? 1,
//       "ddd DD MMM"
//     ),
//     linkUrl: `${window.location.origin}`,
//   });
//   serverPost({
//     url: "user/postmarkEmailSent",
//     data: {
//       to: data?.email ?? "matpfaster26@gmail.com",
//       template: emailTemplate,
//       subject: "Upcoming Delivery Skipped",
//     },
//     onFinish: onFinish,
//   });
// };

export const passwordRestMail = ({
  email = "",
  username = "",
  onFinish = () => {},
}) => {
  const cipherText = Encrypt({ email }, ENCRYPT_KEY).replace(/\//g, "Por21Ld");
  const emailTemplate = passwordResetTemplate({
    username: username,
    linkUrl: `${FRONT_URL}/reset-password/${cipherText}`,
  });
  serverPost({
    url: "user/postmarkEmailSent",
    data: {
      // to: "rowellcamero08@gmail.com",
      to: email ?? "matpfaster26@gmail.com",
      template: emailTemplate,
      subject: "Password Reset",
    },
    onFinish: onFinish,
  });
};

export function Encrypt(word, key = "share") {
  let encJson = CryptoJS.AES.encrypt(JSON.stringify(word), key).toString();
  let encData = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encJson));
  return encData;
}

export function Decrypt(word, key = "share") {
  let decData = CryptoJS.enc.Base64.parse(word).toString(CryptoJS.enc.Utf8);
  let bytes = CryptoJS.AES.decrypt(decData, key).toString(CryptoJS.enc.Utf8);
  return JSON.parse(bytes);
}
